import {Component, Inject} from '@angular/core';
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AuthService} from "../../../services/AuthService";
import {BasicEventPlayer} from "../../../entities/auth/BasicEventPlayer";
import {EventBooth} from "../../../entities/booths/EventBooth";
import {SimplePlayer} from "../../../entities/players/SimplePlayer";
import {APIService} from "../../../services/APIService";

@Component({
  selector: 'app-edit-dialogue',
  templateUrl: './edit-dialogue.component.html',
  styleUrls: ['./edit-dialogue.component.css']
})
export class EditDialogueComponent {
  types: string[] = ['Small', 'Medium', 'Large']

  nameGroup = this._formBuilder.group({
    secondCtrl: ['', Validators.required],
  });
  typeGroup = this._formBuilder.group({
    secondCtrlb: ['', Validators.required],
  });
  ownerGroup = this._formBuilder.group({
    secondCtrlc: ['', Validators.required],

  });

  nameControl: FormControl;
  typeControl: FormControl;
  ownerControl: FormControl;

  owner: BasicEventPlayer;

  constructor(private _formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<EditDialogueComponent>,
              private auth: AuthService,
              private api: APIService,
              @Inject(MAT_DIALOG_DATA) public booth: EventBooth) {
    this.nameControl = new FormControl(booth.name);
    this.typeControl = new FormControl(booth.type);
    api.getPlayer(booth.owner.uuid).then((p) => this.owner = p);
  }

  changeOwner(event: BasicEventPlayer) {
    this.owner = event;
  }

  save() {
    this.dialogRef.close({
      name: this.nameControl.value,
      type: this.typeControl.value,
      owner: this.owner.uuid
    });
  }
}
